var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 7.99888C1.75 4.54772 4.54772 1.75 7.99888 1.75C11.45 1.75 14.2478 4.54772 14.2478 7.99888C14.2478 11.45 11.45 14.2478 7.99888 14.2478C4.54772 14.2478 1.75 11.45 1.75 7.99888ZM7.15442 6.094C6.86152 5.80111 6.38665 5.80111 6.09376 6.094C5.80086 6.38689 5.80086 6.86177 6.09376 7.15466L6.93815 7.99905L6.09376 8.84344C5.80086 9.13633 5.80086 9.61121 6.09376 9.9041C6.38665 10.197 6.86152 10.197 7.15442 9.9041L7.99881 9.05971L8.8432 9.9041C9.13609 10.197 9.61096 10.197 9.90386 9.9041C10.1967 9.61121 10.1967 9.13633 9.90386 8.84344L9.05947 7.99905L9.90386 7.15466C10.1967 6.86177 10.1967 6.38689 9.90386 6.094C9.61096 5.80111 9.13609 5.80111 8.8432 6.094L7.99881 6.93839L7.15442 6.094Z",
    fill: "#B4371B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.9df9e7b39ad350dbde3ba7cadb7ab621.svg";
export { ForwardRef as ReactComponent };